import { ExternalRedirect } from "@router/external-redirect";
import { LoadingScreen } from "@flat-ui";
import { useLegalRedirect } from "@hooks/use-legal-redirect";

/**
 * Component that handles legal page redirects including hash-based routes
 *
 * This is necessary because React Router does not handle URL hash fragments,
 * so we need to manually check the hash and redirect accordingly.
 */
export function LegalHashRedirect(): JSX.Element {
  const { targetUrl } = useLegalRedirect();

  if (!targetUrl) {
    return <LoadingScreen />;
  }

  return <ExternalRedirect targetUrl={targetUrl} />;
}
